<div class="flex flex-col top-chatbot-container gap-1 items-center ">
  <div class="chatbot-chat-container w-full" [class.limit-reached]="limitReached()" role="region" aria-label="Chat input">
    <!-- Main input container with message area and action buttons -->
    <div class="chatbot-input-container">
      <!-- Text input area for chat messages -->
      <label for="chatbot-input" class="sr-only">Chat message input</label>
      <textarea
        id="chatbot-input"
        class="chatbot-input dsr-typescale-body-small"
        matInput
        type="text"
        [readonly]="limitReached()"
        [formControl]="message()"
        [attr.placeholder]="limitReached() ? ('CHATBOT_LIMIT_PLACEHOLDER' | translate) : ''"
        aria-label="Chat message input"
        (keydown.enter)="onEnterPressed($event)"
        (input)="onMessageInput()"
        maxlength="{{ CHATBOT_CHAR_LIMIT }}"></textarea>
    </div>
  
    <!-- Send message button -->
    <button
      type="button"
      class="send-message-button"
      mat-icon-button
      aria-label="Send message"
      color="primary"
      [disabled]="!canSendMessage() || limitReached()"
      (click)="onsubmitBtnClicked()">
      <dsr-icon aria-hidden="true" name="navigation"></dsr-icon>
    </button>
  </div>
  <div class="flex justify-between items-center w-full px-2">
      <span class="dsr-typescale-body-small limit">
        {{ chatbotCharCount() }} / {{ CHATBOT_CHAR_LIMIT }}
      </span>
      <span class="dsr-typescale-body-small message-counter" [style.color]="messageCounterColor">
        <dsr-icon name="speechcomment" size="1.2rem" [color]="messageCounterColor" aria-hidden="true"></dsr-icon>
        {{ remainingMessages() }}
      </span>
    </div>
</div>